import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { LabsService, type Lab, type LabCreate, type LabUpdate } from "@/lib/api_client";
import { getAuthHeaders } from "@/lib/api";
import { fetchAll } from "./fetchAll";

export const useLabs = () =>
  useQuery({
    queryKey: ["labs"],
    queryFn: () => fetchAll<Lab>((opts) => LabsService.getApiLabs({ ...opts, query: { ...opts.query, order: "createdAt.asc" } })),
    staleTime: 5 * 60_000,
  });

export const useCreateLab = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: LabCreate) => {
      const res = await LabsService.postApiLabs({ body: data, headers: getAuthHeaders() });
      if (!res.data) throw new Error("Failed");
      return res.data as unknown as Lab;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["labs"] }),
  });
};

export const useUpdateLab = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: LabUpdate }) => {
      const res = await LabsService.putApiLabsById({ path: { id }, body: data, headers: getAuthHeaders() });
      if (!res.data) throw new Error("Failed");
      return res.data as unknown as Lab;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["labs"] }),
  });
};

export const useDeleteLab = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await LabsService.deleteApiLabsById({ path: { id }, headers: getAuthHeaders() });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["labs"] }),
  });
};
